import { api } from "@/api/client";
import type {
  CheckResult,
  CreatedDocumentView,
  InvoiceDetail,
  InvoicePreview,
  InvoiceSummary,
  VerifyReadinessResponse,
} from "@/types/api";

export async function checkInvoices(files: File[]): Promise<CheckResult[]> {
  const form = new FormData();
  files.forEach((f) => form.append("files", f));
  const { data } = await api.post<CheckResult[]>("/invoices/check", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function uploadInvoice(file: File): Promise<InvoiceDetail> {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post<InvoiceDetail>("/invoices/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function listInvoices(): Promise<InvoiceSummary[]> {
  const { data } = await api.get<InvoiceSummary[]>("/invoices");
  return data;
}

export async function getInvoice(id: string): Promise<InvoiceDetail> {
  const { data } = await api.get<InvoiceDetail>(`/invoices/${id}`);
  return data;
}

export async function previewInvoice(id: string): Promise<InvoicePreview> {
  const { data } = await api.get<InvoicePreview>(`/invoices/${id}/preview`);
  return data;
}

export async function deleteInvoice(id: string): Promise<void> {
  await api.delete(`/invoices/${id}`);
}

export async function batchDeleteInvoices(ids: string[]): Promise<void> {
  await api.post("/invoices/batch-delete", { ids });
}

export async function verifyReadiness(): Promise<VerifyReadinessResponse> {
  const { data } = await api.post<VerifyReadinessResponse>(
    "/invoices/verify-readiness",
  );
  return data;
}

export async function createInvoiceIn1C(id: string): Promise<CreatedDocumentView> {
  const { data } = await api.post<CreatedDocumentView>(
    `/invoices/${id}/create-in-1c`,
  );
  return data;
}
